<template>
    <div class="sidebar">
        <el-menu
            class="sidebar-el-menu"
            @select="chenxcc"
            :default-active="onRoutes"
            :collapse="collapse"
            text-color="#666666"
            active-text-color="#20a0ff"
            unique-opened
            router
        >
            <template v-for="item in permissionList">
                <template v-if="item.f_word && item.f_word.length != 0">
                    <el-submenu :index="item.index" :key="item.index">
                        <template slot="title">
                            <i :class="item.icon"></i>
                            <span slot="title">{{ getMenuTitle(item) }}</span>
                        </template>
                        <template v-for="subItem in item.f_word">
                            <el-submenu v-if="subItem.f_word && subItem.f_word.length != 0" :index="subItem.index" :key="subItem.index">
                                <template slot="title">{{ getMenuTitle(subItem) }}</template>
                                <el-menu-item v-for="(threeItem, i) in subItem.f_word" :key="i" :index="threeItem.index">{{
                                    getMenuTitle(threeItem)
                                }}</el-menu-item>
                            </el-submenu>
                            <el-menu-item v-else :index="subItem.index" :key="subItem.index + 1">{{ getMenuTitle(subItem) }}</el-menu-item>
                        </template>
                    </el-submenu>
                </template>
                <template v-else>
                    <el-menu-item :index="item.index" :key="item.index">
                        <i :class="item.icon"></i>
                        <span slot="title">{{ getMenuTitle(item) }}</span>
                    </el-menu-item>
                </template>
            </template>
        </el-menu>
    </div>
</template>

<script>
import bus from '../common/bus';
import Nav from './nav.js';
import { apiPermissonAll, apiPermissonSlider, apiSystemModule, staffParameter } from '@/request/api';
export default {
    data() {
        return {
            ishow: false,
            type: '',
            collapse: false,
            permissionList: [],
            items: Nav.navData1,
            items2: Nav.navData,
            peopleList: ''
        };
    },
    computed: {
        onRoutes() {
            return this.$route.path.replace('/', '');
        }
    },
    watch: {
        $route(n) {
            this.type = localStorage.getItem('type') || '销售管理';
        }
    },
    created() {
        this.type = localStorage.getItem('type') || '销售管理';
        bus.$on('request', () => {
            this.type = localStorage.getItem('type') || '销售管理';
            this.getData();
        });
        // 通过 Event Bus 进行组件间通信，来折叠侧边栏
        bus.$on('collapse', msg => {
            this.collapse = msg;
            bus.$emit('collapse-content', msg);
        });
        this.getData();
        this.getValidator();
    },
    methods: {
        // 获取菜单标题，优先使用国际化翻译
        getMenuTitle(item) {
            // 优先使用 code_id，如果没有则使用 id
            const menuId = item.code_id || item.id;
            if (menuId) {
                const translated = this.$t(`navMenu.${menuId}`);
                // 如果翻译存在且不等于键名本身，则使用翻译
                if (translated && !translated.startsWith('navMenu.')) {
                    return translated;
                }
            }
            // 如果没有id或没有翻译，使用原始title
            return item.title;
        },
        getData() {
            apiPermissonSlider({
                type_name: this.type
            }).then(res => {
                if (res.code == 2000) {
                    this.permissionList = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        //常用模块
        chenxcc(index) {
            //
            apiSystemModule({
                code: index
            }).then(res => {
                if (res.code == 2000) {
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        getValidator() {
            staffParameter({}).then(res => {
                if (res.code == 2000) {
                    let validatorData = JSON.stringify(res.data);
                    sessionStorage.setItem('validatorData', validatorData);
                } else {
                    this.$message.error(res.msg);
                }
            });
        }
    }
};
</script>

<style scoped>
.sidebar {
    display: block;
    position: absolute;
    left: 0;
    top: 85px;
    bottom: 0;
    overflow-y: scroll;
}
.sidebar::-webkit-scrollbar {
    width: 0;
}
.sidebar-el-menu:not(.el-menu--collapse) {
    width: 200px;
}
.sidebar-el-menu .is-active {
    background: rgba(0, 162, 255, 0.1);
}
.sidebar > ul {
    height: 100%;
}
.el-submenu .el-menu-item {
    text-align: center;
}
.el-menu-item {
    height: 40px !important;
    line-height: 40px !important;
}
</style>
